import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SpinnerService } from './spinner.service';

@Component({
  selector: 'hb-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css'],
})
export class SpinnerComponent implements OnInit, OnDestroy {
  hidden: boolean;
  display: string;
  secondsPassed: number = 0;

  private unsubscribe: Subject<boolean> = new Subject();

  private showCount = 0;

  constructor(private spinnerService: SpinnerService, private changeDetector: ChangeDetectorRef) { }

  ngOnInit() {
    this.spinnerService.visibleChanged.pipe(takeUntil(this.unsubscribe)).subscribe(visible => {
      if (visible) {
        this.showCount++;
      } else {
        if (this.showCount > 0) {
          this.showCount--;
        }
      }

      const shouldBeHidden = (this.showCount <= 0);
      if (this.hidden !== shouldBeHidden) {
        this.hidden = shouldBeHidden;
        this.display = !shouldBeHidden ? 'block' : 'none';
      }
      this.changeDetector.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe.next(true);
    this.unsubscribe.complete();
  }
}
